/**
 * Thu thap va giu lai thong tin quy ket quang cao (attribution).
 *
 * Van de truoc day: backend va Google Sheet deu co san 4 truong
 * utm_source / utm_medium / utm_campaign / fbclid, nhung khong form nao gui
 * len - nen 4 cot trong Sheet luon rong va khong biet lead den tu campaign nao.
 *
 * Cach hoat dong: doc query string ngay khi vao trang lan dau roi cat vao
 * sessionStorage. Nho vay khach bam quang cao vao "/?utm_source=facebook"
 * rui chuyen sang "/car-insurance" (mat query string) thi luc submit form
 * van con du thong tin nguon.
 */

const STORAGE_KEY = "bhtd_attribution";

const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "fbclid"];

/** Doc sessionStorage an toan - che do rieng tu cua Safari co the nem loi. */
function safeRead() {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function safeWrite(value) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    /* khong luu duoc thi thoi, khong duoc lam vo trang */
  }
}

/**
 * Goi mot lan luc khoi dong app.
 *
 * Chi ghi de khi URL hien tai that su co tham so moi - de lan dieu huong sau
 * (khong con query string) khong xoa mat nguon da bat duoc ban dau.
 */
export function captureTracking() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};

    for (const key of FIELDS) {
      const value = params.get(key);
      if (value) found[key] = value.slice(0, 200);
    }

    // Facebook doi khi dung fbclid o dang khac; gclid de danh cho Google Ads
    const gclid = params.get("gclid");
    if (gclid && !found.utm_source) found.utm_source = "google";

    if (Object.keys(found).length > 0) {
      safeWrite({ ...(safeRead() || {}), ...found });
    }
  } catch {
    /* khong duoc de loi tracking lam hong trang */
  }
}

/**
 * Tra ve payload attribution de tron vao body khi submit form.
 * Luon tra ve du 4 khoa (null neu khong co) cho khop voi model backend.
 */
export function getTracking() {
  const stored = safeRead() || {};
  const out = {};
  for (const key of FIELDS) {
    out[key] = stored[key] || null;
  }
  return out;
}
